module.exports = __webpack_public_path__ + "static/animation-ccd3eb39ddbe17c5b69b67c600a5abc0.svg";